import { useClerk } from '@clerk/clerk-react';
import React from 'react';
import type { EnvName, MetricWindow } from '../../../shared/types';
import { GLoading, GPill, GTabs } from '../design/atoms';
import { fmtAge } from '../fmt';
import { useEnvStore } from '../store/envStore';
import { useSession } from '../store/sessionStore';

const ENV_TABS: ReadonlyArray<{ id: EnvName; label: string; title: string }> = [
  { id: 'prod', label: 'prod', title: 'projector-studio 603434660403' },
  { id: 'test', label: 'test', title: 'cteffects 959416850832' },
];
const WINDOW_TABS: ReadonlyArray<{ id: MetricWindow; label: string }> = [
  { id: '1h', label: '1h' }, { id: '24h', label: '24h' }, { id: '7d', label: '7d' },
];

export function TopBar() {
  const { env, window: win, setEnv, setWindow, load, loading, overview } = useEnvStore();
  const { me } = useSession();
  const { signOut } = useClerk();
  const [theme, setTheme] = React.useState<'dark' | 'light'>(() => (document.documentElement.dataset.theme === 'light' ? 'light' : 'dark'));
  const toggleTheme = () => {
    const next = theme === 'dark' ? 'light' : 'dark';
    document.documentElement.dataset.theme = next;
    try { localStorage.setItem('pd-theme', next); } catch { /* ignore */ }
    setTheme(next);
  };
  const asOf = overview[env]?.asOf;

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 22, padding: '14px 28px', borderBottom: '1px solid var(--bd-soft)', flexShrink: 0, flexWrap: 'wrap' }}>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 10 }}>
        <span style={{ fontFamily: 'var(--ff-sans)', fontSize: 16, fontWeight: 500, letterSpacing: '-0.02em' }}>Projector admin</span>
        <span className={env === 'prod' ? 'pd-env-prod' : ''} style={{ fontFamily: 'var(--ff-code)', fontSize: 12.5, color: env === 'prod' ? undefined : 'var(--fg-3)' }}>
          {env === 'prod' ? '● production' : '○ test'}
        </span>
      </div>
      <GTabs items={ENV_TABS} value={env} onChange={setEnv} ariaLabel="Environment" />
      <GTabs items={WINDOW_TABS} value={win} onChange={setWindow} ariaLabel="Window" />
      <div style={{ flex: 1 }} />
      <span style={{ fontFamily: 'var(--ff-code)', fontSize: 12, color: 'var(--fg-4)' }}>
        {loading ? <GLoading label="Refreshing…" /> : asOf ? `as of ${fmtAge(asOf)}` : ''}
      </span>
      <GPill onClick={() => void load()} disabled={loading} title="Re-read everything for this environment">Refresh</GPill>
      <GPill onClick={toggleTheme} title="Switch theme">{theme === 'dark' ? 'Light' : 'Dark'}</GPill>
      <span style={{ fontFamily: 'var(--ff-code)', fontSize: 12, color: 'var(--fg-3)' }} title={me?.sub}>
        {me?.email ?? me?.sub} · {me?.role}{me?.role === 'operator' && !me.mfa ? ' (no MFA)' : ''}
      </span>
      <GPill onClick={() => void signOut()}>Sign out</GPill>
    </div>
  );
}
